import { TFunction } from 'i18next';

import { Dictionary } from '#/shared/dictionaries';
import { UserGender } from '#/shared/types';

export class UserGenderDictionary extends Dictionary<typeof UserGender> {
  constructor(t: TFunction) {
    super(UserGender, t, 'userGender');
  }
}
